import React from 'react'
import { string, bool, node, func } from 'prop-types'

const CheckBox = ({
  label,
  children,
  handleChange,
  defaultChecked,
  hasError,
  errorMsg,
  className,
  disabled,
  ...rest
}) => (
  <label className={`${className} check-box`} {...rest}>
    {children || label}
    <input
      type="checkbox"
      onChange={handleChange}
      defaultChecked={defaultChecked}
    />
    <span className={`checkmark ${hasError ? 'error' : ''} ${disabled ? 'disabled' : ''}`} />
    {hasError && errorMsg && <div className="input-error" role="alert">{errorMsg}</div>}
  </label>
)

CheckBox.propTypes = {
  label: string,
  children: node,
  handleChange: func,
  defaultChecked: bool,
  hasError: bool,
  errorMsg: string,
  className: string,
  disabled: bool,
}

CheckBox.defaultProps = {
  label: '',
  children: null,
  handleChange: () => {},
  defaultChecked: false,
  hasError: false,
  errorMsg: '',
  className: '',
  disabled: false,
}

export default CheckBox
